import jwtDecode, { JwtPayload } from 'jwt-decode';
import { memoize } from 'lodash';

/**
 * Decode JWT, memonized.
 */
export const decodeJwt = memoize(<T = {}>(token: string) => jwtDecode<JwtPayload & T>(token));
